export const fonts = {
  inter: "'Inter', serif",
  grotesk: "'Cabinet Grotesk', sans-serif",
  manrope: "'Manrope', sans-serif",
};
